import Footer from "../components/Footer";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import swal from "sweetalert";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
import AnimatedPage from "../components/AnimatedPage";

function AddMoney() {
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [bank, setBank] = useState(null);
    const [setting, setSetting] = useState(JSON.parse(localStorage.getItem("setting")));
    const [payment, setPayment] = useState([]);
    const [loading, setLoading] = useState(false);
    const [listBank, setListBank] = useState(null);
    
    // --- STATE CHO 2 BƯỚC TẠO HÓA ĐƠN ---
    const [amount, setAmount] = useState(""); 
    const [invoiceStep, setInvoiceStep] = useState(1); 
    const [transferCode, setTransferCode] = useState("");
    const [timeLeft, setTimeLeft] = useState(0); 
    
    const predefinedAmounts = [50000, 100000, 200000, 500000, 1000000, 5000000];
    const { id } = useParams();
    const navigate = useNavigate();

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    const handleBackClick = () => {
        navigate(-1);
    };

    // Đếm ngược 15 phút ở Bước 2
    useEffect(() => {
        let timer;
        if (invoiceStep === 2 && timeLeft > 0) {
            timer = setInterval(() => setTimeLeft((prev) => prev - 1), 1000);
        } else if (invoiceStep === 2 && timeLeft === 0) {
            swal("Hết thời gian", "Hóa đơn đã hết hạn, vui lòng tạo lại.", "warning").then(() => {
                setInvoiceStep(1);
                setAmount("");
                setTransferCode("");
            });
        }
        return () => clearInterval(timer);
    }, [invoiceStep, timeLeft]);

    const formatTime = (seconds) => {
        const m = Math.floor(seconds / 60).toString().padStart(2, "0");
        const s = (seconds % 60).toString().padStart(2, "0");
        return `${m}:${s}`;
    };

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                if (profile != res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            }).catch(() => localStorage.removeItem("user"));
            
        if (id === "auto") {
            axios.get(`${process.env.REACT_APP_API_URL}/bank/getbanks`, {})
                .then((res) => setListBank(res.data.data))
                .catch(() => setBank(null));
        }
        
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getbank`, {})
            .then((res) => setBank(res.data.data))
            .catch(() => setBank(null));
            
        axios.get(`${process.env.REACT_APP_API_URL}/setting/get`, {})
            .then((res) => {
                if (setting != res.data.data[0]) {
                    setSetting(res.data.data[0]);
                    localStorage.setItem("setting", JSON.stringify(res.data.data[0]));
                }
            });
            
        axios.get(`${process.env.REACT_APP_API_URL}/payment/paymentus`, {})
            .then((res) => {
                if (res.data.data) setPayment(res.data.data);
            }).catch(() => {});
    }, []);

    const [activeOption, setActiveOption] = useState(null);
    const handleOptionClick = (option) => {
        setActiveOption(option);
    };

    const handleSelectAmount = (val) => {
        setAmount(val.toLocaleString("vi-VN"));
    };

    const handleInputChange = (e) => {
        const rawValue = e.target.value.replaceAll(".", "").replaceAll(",", "");
        if (!isNaN(rawValue) && rawValue !== "") {
            setAmount(Number(rawValue).toLocaleString("vi-VN"));
        } else {
            setAmount("");
        }
    };

    // --- HÀM TẠO HÓA ĐƠN GỘP API ---
    const handleCreateInvoice = (e) => {
        e.preventDefault();
        const rawAmount = Number(amount.replaceAll(".", "").replaceAll(",", ""));

        if (rawAmount <= 0 || isNaN(rawAmount)) {
            swal("Thông báo", "Vui lòng nhập số tiền hợp lệ", "error");
            return;
        }
        if (rawAmount < setting?.minnap) {
            swal("Chú ý", `Số tiền nạp tối thiểu là ${(setting?.minnap).toLocaleString('vi-VN')}`, "warning");
            return;
        }
        if (rawAmount > setting?.maxnap) {
            swal("Chú ý", `Số tiền nạp tối đa là ${(setting?.maxnap).toLocaleString('vi-VN')}`, "warning");
            return;
        }

        if (id === "auto") {
            if (!activeOption) {
                swal("Chú ý", "Vui lòng chọn ngân hàng", "warning");
                return;
            }
            setLoading(true);
            axios.post(`${process.env.REACT_APP_API_URL}/bank/createTrans`, {
                amount: rawAmount,
                type: activeOption
            }).then((res) => {
                window.location.href = res.data.data.url;
                setLoading(false);
            }).catch((err) => {
                swal("Thất bại", err.response?.data?.message || "Ngân hàng bảo trì", "error");
                setLoading(false);
            });
        } 
        else {
            // Kiểm tra lệnh Pending trước khi gọi API
            if (payment) {
                const count = payment.filter((obj) => obj.status_payment === "Pending" && obj.type_payment === "NẠP");
                if (count.length >= 10) {
                    swal("Thông báo", `Bạn đang có lệnh nạp tiền chưa xử lý. Vui lòng thanh toán hoặc chờ hệ thống.`, "error");
                    return false;
                }
            }

            const randomString = Math.random().toString(36).substring(2, 7).toUpperCase();
            const contentTransfer = `${randomString} ${profile?.username || ""}`; 

            const formData = {
                money: rawAmount,
                type_payment: "NẠP",
                detail: id === "usdt" ? id : contentTransfer,
                status_payment: "Pending",
                user: profile._id
            };

            setLoading(true);
            axios.post(`${process.env.REACT_APP_API_URL}/payment/withDraw`, formData)
                .then((res) => {
                    setLoading(false);
                    setTransferCode(randomString);
                    setTimeLeft(900); 
                    setInvoiceStep(2); 
                    // Cập nhật lại danh sách payment để state biết có lệnh Pending mới
                    axios.get(`${process.env.REACT_APP_API_URL}/payment/paymentus`).then((pRes) => {
                        if (pRes.data.data) setPayment(pRes.data.data);
                    });
                })
                .catch((err) => {
                    setLoading(false);
                    swal("Thất bại", err.response?.data?.message || "Đã xảy ra lỗi", "error");
                });
        }
    };

    // --- NÚT ĐÃ CHUYỂN KHOẢN TẠI BƯỚC 2 ---
    const handleConfirmTransfer = () => {
        // Lệnh đã tạo từ Bước 1, nên ở đây chỉ cần hiện thông báo và reset UI
        swal("Đã ghi nhận", "Hệ thống đang kiểm tra giao dịch của bạn. Tiền sẽ được cộng trong vài phút.", "success").then(() => {
            setInvoiceStep(1);
            setAmount("");
            setTransferCode("");
            setTimeLeft(0);
            navigate("/recharge_record"); // Chuyển về trang lịch sử
        });
    };

    const handleCopyClick = (text) => {
        const tempInput = document.createElement("input");
        tempInput.value = text;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand("copy");
        document.body.removeChild(tempInput);
        swal("Thành công", "Đã copy", "success");
    };

    // Hàm tải ảnh QR code về máy
    const handleDownloadQR = async (imageUrl, fileName) => {
        try {
            const response = await fetch(imageUrl);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = fileName || "QR_Code.png";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            swal("Thành công", "Đã tải mã QR về máy", "success");
        } catch (error) {
            console.error("Lỗi tải QR:", error);
            swal("Lỗi", "Không thể tải ảnh tự động, vui lòng nhấn giữ vào ảnh để lưu.", "error");
        }
    };

    const CopyButton = ({ text }) => (
        <span 
            onClick={() => handleCopyClick(text)} 
            style={{ backgroundColor: "#3b82f6", color: "white", padding: "4px 8px", borderRadius: "5px", fontSize: "12px", cursor: "pointer", marginLeft: "8px", fontWeight: "bold" }}
        >
            Copy
        </span>
    );

    const contentTransfer = `${transferCode} ${profile?.username || ""}`;

    return (
        <>
            {loading === true ? (
                <div className="loading">
                    <div className="loader"></div>
                </div>
            ) : null}
            <div className="title-top">
                <div className="back" onClick={handleBackClick}>
                    <KeyboardArrowLeftOutlinedIcon />
                </div>
                <h1 className="title-h1">Nạp tiền {id === "momo" ? "qua ví Momo" : id === "bank" ? "qua ngân hàng" : "siêu tốc"}</h1>
            </div>
            
            <div className="main">
                <AnimatedPage>
                    <div className="content_profile">
                        <div className="content_bank">
                            
                            {/* BƯỚC 1: NHẬP SỐ TIỀN */}
                            {invoiceStep === 1 && (
                                <>
                                    {id === "auto" && (
                                        <ul className="tab-navigation tab-bank" style={{ marginBottom: "20px" }}>
                                            {listBank?.map((item, index) => (
                                                <li key={index} className={activeOption === item.code ? "active" : ""} onClick={() => handleOptionClick(item.code)}>
                                                    <img src={`https://api.vietqr.io/img/${item.napas_code}.png`} alt="bank_logo"/>
                                                </li>
                                            ))}
                                            {!listBank ? (
                                                <div className="loading"><div className="loader"></div></div>
                                            ) : (
                                                <li className={activeOption === "momo" ? "active" : ""} onClick={() => handleOptionClick("momo")}>
                                                    <img src="/images/momo.png" alt="momo_logo"/>
                                                </li>
                                            )}
                                        </ul>
                                    )}

                                    <div style={{ marginBottom: "20px" }}>
                                        <div className="input" style={{ marginBottom: "15px" }}>
                                            <label style={{ fontWeight: "bold", display: "block", marginBottom: "8px" }}>Nhập số tiền (VND)</label>
                                            <input
                                                className="ipadd"
                                                type="text"
                                                value={amount}
                                                onChange={handleInputChange}
                                                placeholder="Nhập hoặc chọn số tiền bên dưới..."
                                                style={{
                                                    width: "100%", padding: "14px 18px", fontSize: "16px", fontWeight: "600",
                                                    borderRadius: "10px", outline: "none", boxSizing: "border-box"
                                                }}
                                            />
                                        </div>

                                        <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginBottom: "20px" }}>
                                            {predefinedAmounts.map((val, idx) => (
                                                <button 
                                                    key={idx} type="button" onClick={() => handleSelectAmount(val)}
                                                    style={{ flex: "1 1 calc(33.333% - 10px)", minWidth: "90px", padding: "10px", border: "1px solid #e2e8f0", borderRadius: "8px", cursor: "pointer", fontWeight: "bold", background: "transparent", color: "inherit" }}
                                                >
                                                    {val.toLocaleString("vi-VN")}
                                                </button>
                                            ))}
                                        </div>

                                        <button className="btn-submit" onClick={handleCreateInvoice} style={{ width: "100%", padding: "14px", fontSize: "16px", fontWeight: "bold", borderRadius: "10px", cursor: "pointer" }}>
                                            {id === "auto" ? "Thanh Toán Tự Động" : "Tạo Hóa Đơn"}
                                        </button>
                                    </div>
                                </>
                            )}

                            {/* BƯỚC 2: QUÉT QR */}
                            {invoiceStep === 2 && bank && id !== "auto" && (
                                <div style={{ textAlign: "center", paddingBottom: "20px" }}>
                                    <h3 style={{ color: "#d9534f", marginBottom: "10px", fontSize: "20px" }}>Quét Mã QR Để Thanh Toán</h3>
                                    
                                    <div style={{ marginBottom: "20px", fontSize: "15px" }}>
                                        Vui lòng thanh toán trong thời gian: <br/>
                                        <b style={{ color: "red", fontSize: "24px", display: "inline-block", marginTop: "5px" }}>{formatTime(timeLeft)}</b>
                                    </div>
                                    
                                    {bank.map((item) => {
                                        // GIAO DIỆN MOMO
                                        if (item.isShow && item.name_bank.toLowerCase() === "momo" && id === "momo") {
                                            return (
                                                <div key={item._id} className="item-banks" style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", alignItems: "center", justifyContent: "center", gap: "15px", marginBottom: "20px", padding: "15px", borderRadius: "15px" }}>
                                                    {item?.qr && (
                                                        <div style={{ flexShrink: 0, textAlign: "center" }}>
                                                            <img src={item?.qr} alt="Momo QR" style={{ width: "180px", height: "180px", objectFit: "contain", border: "none" }} />
                                                            <div style={{ marginTop: "10px" }}>
                                                                <button onClick={() => handleDownloadQR(item.qr, "QR_Momo.png")} style={{ padding: "6px 12px", backgroundColor: "#10b981", color: "white", border: "none", borderRadius: "5px", fontSize: "12px", fontWeight: "bold", cursor: "pointer" }}>
                                                                    📥 Tải mã QR
                                                                </button>
                                                            </div>
                                                        </div>
                                                    )}
                                                    <div style={{ fontSize: "14px", lineHeight: "2.2", textAlign: "left", flex: "1", minWidth: "200px", wordBreak: "break-word" }}>
                                                        <div>Số Momo: <b style={{ fontSize: "16px" }}>{item.stk}</b> <CopyButton text={item.stk} /></div>
                                                        <div>Người nhận: <b style={{ fontSize: "16px" }}>{item.fullname}</b></div>
                                                        <div>Số tiền: <b style={{ color: "red", fontSize: "18px" }}>{amount} VNĐ</b> <CopyButton text={amount.replaceAll(".", "")} /></div>
                                                        <div>Nội dung CK: <b style={{ color: "#3b82f6", fontSize: "16px" }}>{contentTransfer}</b> <CopyButton text={contentTransfer} /></div>
                                                    </div>
                                                </div>
                                            );
                                        }

                                        // GIAO DIỆN NGÂN HÀNG
                                        if (item.isShow && item.name_bank.toLowerCase() !== "momo" && item.name_bank.toLowerCase() !== "usdt" && id === "bank") {
                                            const rawAmount = Number(amount.replaceAll(".", "").replaceAll(",", ""));
                                            const qrUrl = `https://img.vietqr.io/image/${item.name_bank}-${item.stk}-vip8bet.png?amount=${rawAmount}&addInfo=${encodeURIComponent(contentTransfer)}&accountName=${encodeURIComponent(item.fullname)}`;
                                            
                                            return (
                                                <div key={item._id} className="item-banks" style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", alignItems: "center", justifyContent: "center", gap: "15px", marginBottom: "20px", padding: "15px", borderRadius: "15px" }}>
                                                    <div style={{ flexShrink: 0, textAlign: "center" }}>
                                                        <img src={qrUrl} alt="Bank QR" style={{ width: "200px", height: "200px", objectFit: "contain", border: "none" }} />
                                                        <div style={{ marginTop: "10px" }}>
                                                            <button onClick={() => handleDownloadQR(qrUrl, `QR_${item.name_bank}.png`)} style={{ padding: "6px 12px", backgroundColor: "#10b981", color: "white", border: "none", borderRadius: "5px", fontSize: "12px", fontWeight: "bold", cursor: "pointer" }}>
                                                                📥 Tải mã QR
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div style={{ fontSize: "14px", lineHeight: "2.2", textAlign: "left", flex: "1", minWidth: "200px", wordBreak: "break-word" }}>
                                                        <div>Ngân hàng: <b style={{ color: "red", fontSize: "16px" }}>{item.name_bank}</b></div>
                                                        <div>STK: <b style={{ fontSize: "16px" }}>{item.stk}</b> <CopyButton text={item.stk} /></div>
                                                        <div>Người nhận: <b style={{ fontSize: "16px" }}>{item.fullname}</b></div>
                                                        <div>Số tiền: <b style={{ color: "red", fontSize: "18px" }}>{amount} VNĐ</b> <CopyButton text={amount.replaceAll(".", "")} /></div>
                                                        <div>Nội dung CK: <b style={{ color: "#3b82f6", fontSize: "16px" }}>{contentTransfer}</b> <CopyButton text={contentTransfer} /></div>
                                                    </div>
                                                </div>
                                            );
                                        }

                                        // GIAO DIỆN USDT
                                        if (item.isShow && item.name_bank.toLowerCase() === "usdt" && id === "usdt") {
                                            return (
                                                <div key={item._id} className="item-banks" style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", alignItems: "center", justifyContent: "center", gap: "15px", marginBottom: "20px", padding: "15px", borderRadius: "15px" }}>
                                                    {item?.qr && (
                                                        <div style={{ flexShrink: 0, textAlign: "center" }}>
                                                            <img src={item?.qr} alt="USDT QR" style={{ width: "180px", height: "180px", objectFit: "contain", border: "none" }} />
                                                            <div style={{ marginTop: "10px" }}>
                                                                <button onClick={() => handleDownloadQR(item.qr, "QR_USDT.png")} style={{ padding: "6px 12px", backgroundColor: "#10b981", color: "white", border: "none", borderRadius: "5px", fontSize: "12px", fontWeight: "bold", cursor: "pointer" }}>
                                                                    📥 Tải mã QR
                                                                </button>
                                                            </div>
                                                        </div>
                                                    )}
                                                    <div style={{ fontSize: "14px", lineHeight: "2.2", textAlign: "left", flex: "1", minWidth: "200px", wordBreak: "break-word" }}>
                                                        <div>Địa chỉ ví: <br/><b>{item.stk}</b> <CopyButton text={item.stk} /></div>
                                                        <div>Mạng lưới: <b>{item.title}</b></div>
                                                        <div>Số tiền quy đổi: <b style={{ color: "red", fontSize: "18px" }}>{amount}</b></div>
                                                    </div>
                                                </div>
                                            );
                                        }
                                        return null;
                                    })}

                                    <div style={{ display: "flex", gap: "10px", justifyContent: "center", marginTop: "20px" }}>
                                        <button className="btn-submit" onClick={handleConfirmTransfer} style={{ flex: 1, padding: "14px", borderRadius: "10px", fontWeight: "bold", fontSize: "15px", cursor: "pointer" }}>
                                            Đã Chuyển Khoản
                                        </button>
                                        <button onClick={() => { setInvoiceStep(1); setTimeLeft(0); }} style={{ padding: "14px 20px", backgroundColor: "#6c757d", color: "white", border: "none", borderRadius: "10px", fontWeight: "bold", fontSize: "15px", cursor: "pointer" }}>
                                            Hủy
                                        </button>
                                    </div>
                                </div>
                            )}

                        </div>

                        {/* HƯỚNG DẪN */}
                        <div className="text_choose_center huongdan" style={{ marginTop: "25px", padding: "15px", borderRadius: "10px" }}>
                            <div className="title" style={{ margin: "0 0 10px", padding: "0", fontWeight: "700", color: "#d9534f" }}>
                                📌 Hướng dẫn nạp tiền
                            </div>
                            <ul style={{ paddingLeft: "20px", fontSize: "14px", lineHeight: "1.8", textAlign: "left" }}>
                                <li>Nhập số tiền cần nạp và bấm <b>Tạo Hóa Đơn</b>.</li>
                                <li>Nạp tối tiểu <b>{(setting?.minnap)?.toLocaleString("vi-VN")} VNĐ</b> - Tối đa <b>{(setting?.maxnap)?.toLocaleString("vi-VN")} VNĐ</b>/đơn.</li>
                                <li>Chuyển khoản theo đúng <b>Số tiền</b> và <b>Nội dung chuyển khoản</b> hiển thị ở màn hình quét QR.</li>
                                <li>Sau khi chuyển khoản thành công, bấm nút <b>Đã chuyển khoản</b> để hệ thống ghi nhận. Tiền sẽ được cộng trong 5 phút.</li>
                            </ul>
                        </div>

                    </div>
                </AnimatedPage>
            </div>
            <Footer />
        </>
    );
}
export default AddMoney;